import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { Editor } from '@tinymce/tinymce-react';
import {
  useGetStandardLetterParameterQuery,
  useUpdateCompanyLetterTemplateMutation,
  useUpdateLetterTemplateMutation,
} from 'generated/graphql';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import { SystemMsgs } from 'helpers/Messages/SystemMsg';
import AppContext from 'containers/App/Store/AppContext';
import { useEDocTemplate } from './DocTemplate';
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader';
import { smallTitle } from '@ifca-root/react-component/src/helpers/Global/ContractGlobalVar';
import FullPageLoader from '../../../src/helpers/LoaderPage/FullPageLoader';
export const LetterDesignForm = (props: any) => {
  const {
    pageMode: urlPageMode,
    standardLetterID,
    letterTemplateID,
    companyID,
    companyLetterTemplateID,
  }: any = useParams();
  const pageMode = urlPageMode ?? 'client-account';

  const isHomeDefault = localStorage.getItem('isDefault');
  const user = JSON.parse(localStorage.getItem('loggedInUser'));

  const { globalState, dispatch }: any = useContext(AppContext as any);
  let history = useHistory();
  let location: any = useLocation();
  let editData = location.state;
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any,
  );

  const { htmlWrapper } = useEDocTemplate();
  const [load, setLoad] = useState(false);
  const {
    loading,
    data: { getStandardLetterParameter } = { getStandardLetterParameter: [] },
  } = useGetStandardLetterParameterQuery({
    variables: {
      standardLetterID: standardLetterID,
    },
    fetchPolicy: 'network-only',
  });
  const [
    //updateLetterTemplate to updateLetterTemplate
    updateLetterTemplate,
    { loading: updateLetterTemplateLoading, error: updateLetterTemplateError },
  ] = useUpdateLetterTemplateMutation({
    onError: error => {
      setLoad(false);
      setSnackBarMsg(error.message);
    },
    onCompleted: ({ updateLetterTemplate }) => {
      setLoad(false);
      if (updateLetterTemplate) {
        setOpenSnackBar(true);
        setSnackBarMsg(SystemMsgs.updateRecord());
        history.push({
          pathname: `/general-settings/standard-letter/${standardLetterID}/letter-template`,
        });
      } else {
        setSnackBarMsg('Update Failed!');
      }
    },
  });
  const [
    //updateCompanyLetterTemplate to updateCompanyLetterTemplate
    updateCompanyLetterTemplate,
    {
      loading: updateCompanyLetterTemplateLoading,
      error: updateCompanyLetterTemplateError,
    },
  ] = useUpdateCompanyLetterTemplateMutation({
    onError: error => {
      setLoad(false);
      setSnackBarMsg(error.message);
    },
    onCompleted: ({ updateCompanyLetterTemplate }) => {
      setLoad(false);
      if (updateLetterTemplate) {
        setOpenSnackBar(true);
        setSnackBarMsg(SystemMsgs.updateRecord());
        history.push({
          pathname: `/company-setup/submenu/${companyID}/company-standard-letter/${standardLetterID}/company-letter-template`,
        });
      } else {
        setSnackBarMsg('Update Failed!');
      }
    },
  });

  const [contentValue, setContentValue] = useState('');
  const [ConfirmationDialog, setConfirmationDialog] = useState(false);
  const [IsChange, setIsChange] = useState(false);
  const checkIsChange = (changed: boolean) => {
    if (!changed) {
      return history.goBack();
    } else {
      return setConfirmationDialog(true);
    }
  };

  useEffect(() => {
    if (!!editData) {
      setContentValue(editData?.templateBody);
    }
  }, [editData, document]);

  const newContentValue = contentValue?.replaceAll('&nbsp;', '');

  const onSubmit = () => {
    setLoad(true);
    if (companyID) {
      updateCompanyLetterTemplate({
        variables: {
          input: {
            ID: companyLetterTemplateID,
            templateBody: newContentValue,
          },
        },
      });
    } else {
      updateLetterTemplate({
        variables: {
          input: {
            ID: letterTemplateID,
            templateBody: newContentValue,
          },
        },
      });
    }
  };

  const itemName = getStandardLetterParameter
    ?.map(x => {
      if (x?.columnName === '[DateTime]') return '[Date/Time]';
      return x?.columnName;
    })
    ?.join(' ');

  const newListing = getStandardLetterParameter;

  let headerTitle: string = '';
  switch (pageMode) {
    case 'client-account':
      headerTitle = smallTitle.CLIENT_ACCOUNTS;
      break;
    case 'subcontractor':
      headerTitle = smallTitle.SUBCON_ACCOUNTS;
      break;
    case 'supplier':
      headerTitle = smallTitle.SUPPLIER_ACCOUNTS;
      break;
    case 'client-contract':
      headerTitle = smallTitle.PROJECT_PURCHASES;
      break;
    default:
      headerTitle = smallTitle.PRODUCT;
      break;
  }

  return (
    <>
      {loading && <Loading />}
      {updateLetterTemplateLoading && <Loading />}
      {updateCompanyLetterTemplateLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push({
            pathname: companyID
              ? `/company-setup/submenu/${companyID}/company-standard-letter/${standardLetterID}/company-letter-template`
              : `/general-settings/standard-letter/${standardLetterID}/letter-template`,
          });
        }}
        smTitle={isHomeDefault === 'true' ? 'ContractX' : headerTitle}
        title={user?.companyName}
        routeSegments={
          globalState?.isPathSysAdmin
            ? [
                { name: 'System Admin' },
                { name: 'System Admin' },
                { name: 'Document Template' },
                { name: 'Letter Template', current: true },
              ]
            : [
                { name: 'System Admin' },
                { name: 'Document Template' },
                { name: 'Letter Template', current: true },
              ]
        }
        rightRouteSegments={[
          {
            name: 'Design',
            current: true,
          },
        ]}
      />

      <DynamicSubHeader title={editData?.Name ?? editData?.name} />

      <ContentWrapper search>
        {!loading ? (
          // @ts-expect-error
          <Editor
            apiKey={'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat'}
            init={{
              convert_urls: false,
              plugins:
                'preview paste importcss searchreplace autolink autosave  directionality code visualblocks visualchars fullscreen image link  template table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
              imagetools_cors_hosts: ['picsum.photos'],
              menubar: 'file edit view insert format tools table custom ',
              toolbar:
                'signatureSetupButton customInsertButton | undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview   | insertfile image  template link anchor code | ltr rtl',
              toolbar_sticky: true,
              image_advtab: true,
              //importcss_append: true,
              entity_encoding: 'raw',
              forced_root_block: false,

              menu: {
                custom: {
                  title: 'Parameters',
                  items: itemName,
                },
              },
              setup: function(editor) {
                editor.on('change keyup', function () {
                  const currentValue = editor.getContent();
                  setContentValue(currentValue);
                  // localStorage.setItem('editorContent', currentValue);
                });

                editor.ui.registry.addButton('customInsertButton', {
                  text: 'Reset',
                  onAction: function(_) {
                    setContentValue(editData?.templateBody);
                    setIsChange(true);
                    // editor.insertContent(
                    //   "&nbsp;<strong>It's my button!</strong>&nbsp;"
                    // )
                  },
                });
                editor.ui.registry.addMenuButton('signatureSetupButton', {
                  text: 'Signature Setup',
                  // icon: 'signature', 
                  // tooltip: 'Insert Signature',
                  fetch: function(callback){
                    const items = [
                      {
                        type:'menuitem',
                        text: 'Name Only',
                        onAction: function () {
                          const signatureHtml = `
                            <div style="margin-top:0px; font-family:Arial; font-size:12px;" class="signature-block">
                              <p>[Insert name]<br/>
                              [Insert position]
                              </p>
                            </div>
                          `;
                          // editor.dom.remove(editor.dom.select('.signature-block'));
                          let currentValue = editor.getContent();
                          let dataIndex = 0;
                          const dataText = ['[CreatedBy]', '[SubmittedBy]', '[ApprovedBy]'];
                          currentValue = currentValue.replace(
                             /<div[^>]*class="signature-block"[^>]*>[\s\S]*?<\/div>/g,
                             () => dataText[dataIndex++] || ''
                          );
                          
                          const newValue = currentValue
                          .replace(
                            /\[CreatedBy\]/g, 
                            signatureHtml)
                          .replace(/\[SubmittedBy\]/g, signatureHtml)
                          .replace(/\[ApprovedBy\]/g, signatureHtml);
                          editor.setContent(newValue);
                        },
                      },
                      {
                        type: 'menuitem',
                        text: 'Name + Digital Signature',
                        onAction: function () {
                          const nameSignatureHtml = `
                            <div style="margin-top:5px; font-family:Arial; font-size:12px;" class="signature-block">
                              [Insert Digital Signature Image Here]<br/>
                              <img src="https://repository-images.githubusercontent.com/8805592/85279ffa-7f4a-4880-8e41-59e8032b0f71" alt="Signature" style="width:150px; height:50px;"/><br/>
                              <p>[Insert name]<br/>
                              [Insert position]</p>
                            </div>
                          `;

                          const nameSignature2Html = `
                            <div style="margin-top:5px; font-family:Arial; font-size:12px;" class="signature-block">
                              [Insert Digital Signature Image Here]<br/>
                              <img src="https://upload.wikimedia.org/wikipedia/commons/a/af/Ryan-Signature.png" alt="Signature" style="width:150px; height:50px;"/><br/>
                              <p>[Insert name]<br/>
                              [Insert position]</p>
                            </div>
                          `;

                          const nameSignature3Html = `
                            <div style="margin-top:5px; font-family:Arial; font-size:12px;" class="signature-block">
                              [Insert Digital Signature Image Here]<br/>
                              <img src="https://planetofnames.biz/cdn/shop/products/SimpleDesign.jpg?v=1666923538&width=1946" alt="Signature" style="width:150px; height:50px;"/><br/>
                              <p>[Insert name]<br/>
                              [Insert position]</p>
                            </div>
                          `;
                          let newValue = editor.getContent();
                          let dataIndex = 0;
                          const dataText = ['[CreatedBy]', '[SubmittedBy]', '[ApprovedBy]'];
                          newValue = newValue.replace(
                            /<div[^>]*class="signature-block"[^>]*>[\s\S]*?<\/div>/g,
                            () => dataText[dataIndex++] || ''
                          );
                          const newContent = newValue
                          .replace(/\[CreatedBy\]/g,nameSignatureHtml)
                          .replace(/\[SubmittedBy\]/g,nameSignature2Html )
                          .replace(/\[ApprovedBy\]/g,nameSignature3Html);
                          editor.setContent(newContent);
                        }
                      }
                    ];
                    callback(items)
                  },
                });
                return newListing?.map(x => {
                  const slicedColumnName = x?.columnName
                    ?.replaceAll('[', '')
                    ?.replaceAll(']', '')
                    ?.trim();

                  const newParams =
                    x?.columnName === '[Date/Time]'
                      ? '[DateTime]'
                      : x?.columnName;
                  editor.ui.registry?.addMenuItem(x.columnName, {
                    text: `${slicedColumnName}`,
                    onAction: function() {
                      editor.insertContent(`${newParams}`);
                    },
                  });
                });
              },

              height: 700,
            }}
            value={contentValue}
            onEditorChange={(newValue, editor) => {
              setContentValue(newValue);
              setIsChange(true);
            }}
          />
        ) : null}
        <FullPageLoader open={load} message="Loading" />
        <Footer
          options={[
            {
              name: 'Save',
              onClick: () => onSubmit(),

              color: 'primary',
            },
          ]}
        />
      </ContentWrapper>
    </>
  );
};
